const getRegionLabel = (country) => {
	switch (country) {
		case 'United States':
		case 'US':
			return 'State';
		case 'Canada':
		case 'CA':
			return 'Province / Territory';
		case 'United Kingdom':
		case 'GB':
			return 'County';
		case 'India':
		case 'IN':
			return 'State';
		case 'Australia':
		case 'AU':
			return 'State / Territory';
		default:
			return 'State / Province / Region';
	}
};

const getCityLabel = (country) => {
	switch (country) {
		case 'United States':
		case 'US':
			return 'City';
		case 'Canada':
		case 'CA':
			return 'City';
		case 'Australia':
		case 'AU':
			return 'City';
		case 'United Kingdom':
		case 'GB':
			return 'Post Town';
		case 'India':
		case 'IN':
			return 'City / District';
		default:
			return 'Town / City';
	}
};

const getPostalCodeLabel = (country) => {
	switch (country) {
		case 'United States':
		case 'US':
			return 'Zip Code';
		case 'United Kingdom':
		case 'GB':
			return 'Postcode';
		case 'India':
		case 'IN':
			return 'Pin Code';
		default:
			return 'Postal Code';
	}
};

const getTaxIdLabel = (country) => {
	switch (country) {
		case 'United States':
		case 'US':
			return 'EIN';
		case 'Canada':
		case 'CA':
			return 'Business Number';
		case 'Australia':
		case 'AU':
			return 'ABN';
		case 'United Kingdom':
		case 'GB':
			return 'VAT Reg No';
		case 'India':
		case 'IN':
			return 'GST/PAN';
		default:
			return 'Business / Tax ID';
	}
};

const getTaxIdPrefix = (country) => {
	switch (country) {
		case 'AU':
			return 'ABN';
		case 'GR':
			return 'EL';
		case 'IS':
			return 'VSK';
		case 'GB':
			return 'GB';
		default:
			return null;
	}
};

export {
	getRegionLabel,
	getCityLabel,
	getPostalCodeLabel,
	getTaxIdLabel,
	getTaxIdPrefix,
};
